<div class="title-container">
    <div class="subtitle subtitle-smaller">{{ title }}</div>
    <div class="title bold">{{ "graph.exhaust.title.turbo" | translate }}</div>
</div>

<div
    echarts
    [options]="echartsOptions"
    [extentions]="echartsExtentions"
    (chartInit)="onChartInit($event)"
></div>
